import React from 'react'
import './NotImplemented.css'

const NotImplemented = ({ message }) => {
  return (
    <div className='nn-page'>
      <div className='ni-root w-full'>
        <div className='ni-card'>
          <div className='ni-icon flex justify-center' aria-hidden>
            <svg
              width='96'
              height='96'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path d='M11 9h2v6h-2z' fill='#F97316' />
              <path d='M11 17h2v2h-2z' fill='#FB923C' />
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 18a8 8 0 100-16 8 8 0 000 16z'
                fill='#FDE68A'
              />
            </svg>
          </div>
          <p className='ni-message'>{message}</p>
        </div>
      </div>
    </div>
  )
}

export default NotImplemented
